"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var lodash_uniqueid_1 = tslib_1.__importDefault(require("lodash.uniqueid"));
var react_1 = tslib_1.__importStar(require("react"));
var react_dom_1 = tslib_1.__importDefault(require("react-dom"));
var CLASS_NAME = "body-overflow-media-manager-connector";
var css = "\n  [class*=\"".concat(CLASS_NAME, "\"]{\n    overflow: hidden;\n  }\n");
var MediaManagerConnector = /** @class */ (function (_super) {
    tslib_1.__extends(MediaManagerConnector, _super);
    function MediaManagerConnector(props) {
        var _this = _super.call(this, props) || this;
        _this.iframeEl = null;
        _this.el = null;
        _this.uid = '';
        _this.removeOverflowClass = function () {
            document.body.classList.remove("".concat(CLASS_NAME, "-").concat(_this.uid));
        };
        _this.handleLoad = function () {
            var _a = _this.props.multiple, multiple = _a === void 0 ? true : _a;
            document.body.classList.add("".concat(CLASS_NAME, "-").concat(_this.uid));
            var _b = _this.props, accessToken = _b.accessToken, appId = _b.appId, appSpace = _b.appSpace, onClose = _b.onClose, _c = _b.onSelectFiles, onSelectFiles = _c === void 0 ? null : _c;
            window.removeEventListener('message', _this.handleMessage);
            window.addEventListener('message', _this.handleMessage, false);
            if (typeof onClose === 'function') {
                _this.sendMessages([_this.formatMessage('ON_CLOSE_FN_SET', appId)]);
            }
            if (typeof onSelectFiles === 'function') {
                _this.sendMessages([
                    _this.formatMessage('ON_SELECT_FILES_FN_SET', multiple ? -1 : 1),
                ]);
            }
            var identityMessages = [
                _this.formatMessage('SET_APP_ID', appId),
                _this.formatMessage('SET_ACCESS_TOKEN', accessToken),
            ];
            if (appSpace) {
                identityMessages.push(_this.formatMessage('SET_APP_SPACE', appSpace));
            }
            _this.sendMessages(identityMessages);
        };
        _this.handleMessage = function (e) {
            if (Array.isArray(e.data)) {
                _this.processAlienMessages(e.data);
            }
        };
        _this.processAlienMessages = function (messages) {
            if (messages === void 0) { messages = []; }
            messages.forEach(_this.processSingleAlienMessage);
        };
        _this.processSingleAlienMessage = function (params) {
            var instanceId = params.instanceId, type = params.type, payload = params.payload;
            if (instanceId !== _this.uid) {
                return;
            }
            var _a = _this.props, onError = _a.onError, onUnauthorized = _a.onUnauthorized, onClose = _a.onClose, _b = _a.onSelectFiles, onSelectFiles = _b === void 0 ? null : _b;
            switch (type) {
                case 'MEDIAMANAGER_READY':
                    _this.handleLoad();
                    break;
                case 'ERROR_GENERIC':
                    if (typeof payload === 'string') {
                        onError(payload);
                    }
                    else {
                        throw Error("Unexpected error \"".concat(payload, "\"."));
                    }
                    break;
                case 'ERROR_AUTH':
                    onUnauthorized();
                    break;
                case 'CLOSE':
                    onClose();
                    _this.removeOverflowClass();
                    break;
                case 'FILES_SELECTED':
                    if (onSelectFiles) {
                        onSelectFiles(payload);
                    }
                    break;
                default:
            }
        };
        _this.formatMessage = function (type, payload) {
            return {
                instanceId: _this.uid,
                type: type,
                payload: payload
            };
        };
        _this.sendMessages = function (messages) {
            if (_this.iframeEl && _this.iframeEl.contentWindow) {
                _this.iframeEl.contentWindow.postMessage(messages, '*');
            }
        };
        _this.iframeEl = null;
        _this.uid = (0, lodash_uniqueid_1["default"])();
        _this.el = document.createElement('div');
        _this.el.setAttribute('id', "media-manager-connector-placeholder-instance-".concat(_this.uid));
        _this.removeOverflowClass = _this.removeOverflowClass.bind(_this);
        var head = document.head || document.getElementsByTagName('head')[0];
        var style = document.createElement('style');
        style.type = 'text/css';
        if (style.styleSheet) {
            style.styleSheet.cssText = css;
        }
        else {
            style.appendChild(document.createTextNode(css));
        }
        head.appendChild(style);
        return _this;
    }
    MediaManagerConnector.prototype.componentDidMount = function () {
        if (this.el) {
            document.body.appendChild(this.el);
        }
    };
    MediaManagerConnector.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        if (this.props.opened === true && nextProps.opened === false) {
            this.removeOverflowClass();
        }
    };
    MediaManagerConnector.prototype.componentWillUnmount = function () {
        window.removeEventListener('message', this.handleMessage);
        if (this.el) {
            document.body.removeChild(this.el);
        }
        this.removeOverflowClass();
    };
    MediaManagerConnector.prototype.render = function () {
        var _this = this;
        var _a = this.props, _b = _a.opened, opened = _b === void 0 ? false : _b, _c = _a.mediaManagerBaseUrl, mediaManagerBaseUrl = _c === void 0 ? 'https://mediamanager.sportnet.online' : _c;
        if (!opened) {
            return null;
        }
        if (this.el) {
            return react_dom_1["default"].createPortal(react_1["default"].createElement("iframe", { frameBorder: "0", onLoad: this.handleLoad, ref: function (el) {
                    _this.iframeEl = el;
                }, style: {
                    position: 'fixed',
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    zIndex: 99999
                }, title: "Media Manager", src: "".concat(mediaManagerBaseUrl, "/?instance_id=").concat(this.uid) }), this.el);
        }
        return null;
    };
    return MediaManagerConnector;
}(react_1.Component));
exports["default"] = MediaManagerConnector;
